module.exports = __webpack_public_path__ + "static/img/earplugs.d93c777.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/earplugs.png
// module id = 293
// module chunks = 0